let lastInputWasPointer = false
let pointerFocusedElement: EventTarget | null = null

if (typeof window !== 'undefined') {
  window.addEventListener(
    'pointerdown',
    () => {
      lastInputWasPointer = true
    },
    true,
  )
  window.addEventListener(
    'keydown',
    () => {
      lastInputWasPointer = false
    },
    true,
  )
  window.addEventListener(
    'focus',
    (e) => {
      pointerFocusedElement = lastInputWasPointer ? e.target : null
    },
    true,
  )
}

/**
 * Whether `element` got its current focus from a mouse or touch press rather
 * than the keyboard. Unlike `:focus-visible`, the answer doesn't change when
 * a key is then pressed on the element.
 */
export const wasFocusedByPointer = (element: Element | null) =>
  element !== null && element === pointerFocusedElement
